module.exports = __webpack_public_path__ + "img/trisline-logo2-white.f5f46bb6.png";